import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function PortalServices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    http.get("/portal/services").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="portal-services">
      <h1 className="text-4xl">My Services</h1>
      <p className="mt-2 text-navy/65">Active engagements with the ConnectHer team.</p>
      <div className="mt-8">
        {loading ? (
          <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="card p-10 text-center">
            <h3 className="text-2xl">No active services yet.</h3>
            <p className="mt-2 text-navy/65">Explore our service catalog and get started.</p>
            <Link to="/services" className="btn-primary mt-6 inline-flex">Browse Services</Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-5">
            {items.map((s, i) => (
              <div key={i} className="card p-6" data-testid={`portal-service-${i}`}>
                <div className="flex items-center justify-between">
                  <h3 className="text-xl">{s.name || s.service_name}</h3>
                  <span className="text-[10px] uppercase tracking-widest text-teal">{s.status || "active"}</span>
                </div>
                {s.note && <p className="mt-3 text-sm text-navy/65">{s.note}</p>}
                {s.progress != null && (
                  <div className="mt-4">
                    <div className="text-xs text-navy/55 mb-1">Progress · {s.progress}%</div>
                    <div className="h-2 rounded-full bg-navy/5 overflow-hidden">
                      <div className="h-full bg-gold" style={{ width: `${s.progress}%` }} />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
